import React from 'react';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { Modal } from '../../../components/Modal';

interface SecureAccountModalProps {
    isOpen: boolean;
    onClose: () => void;
    email: string;
    setEmail: (val: string) => void;
    password: string;
    setPassword: (val: string) => void;
    isSubmitting: boolean;
    onSubmit: (e: React.SyntheticEvent<HTMLFormElement>) => void;
}

export const SecureAccountModal: React.FC<SecureAccountModalProps> = ({
    isOpen,
    onClose,
    email, setEmail,
    password, setPassword,
    isSubmitting,
    onSubmit
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Secure Your Account"
        >
            <form onSubmit={onSubmit} className="space-y-4">
                <p className="text-xs text-slate-500">
                    Create an account to link your current data.
                </p>
                <Input
                    label="Email"
                    type="email"
                    placeholder="email@example.com"
                    value={email}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setEmail(e.target.value); }}
                />
                <Input
                    label="Password"
                    type="password"
                    placeholder="Min 6 characters"
                    value={password}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setPassword(e.target.value); }}
                    minLength={6}
                />
                <Button type="submit" className="w-full" disabled={isSubmitting}>
                    {isSubmitting ? 'Securing...' : 'Create Account'}
                </Button>
            </form>
        </Modal>
    );
};
